'use strict';

var UIBootstrap = require('angular-ui-bootstrap');
require('ng-toast');
require('./node_modules/angular-loading-bar/build/loading-bar.min.js');
global.moment = require('moment');

var ngDroCore = angular.module('ngDro-core', ['ngDro', UIBootstrap, 'ngToast', 'angular-loading-bar']);

global.ngDroModules.push(ngDroCore.name);

//******************************* CONFIG ***********************************
ngDroCore.config(require('./configs/StateProvider'));
ngDroCore.config(require('./configs/TranslateProvider'));
ngDroCore.config(require('./configs/NgToastProvider'));
ngDroCore.config(['ngToastProvider', function (ngToast) {
        ngToast.configure({
            verticalPosition: 'top',
            horizontalPosition: 'center',
            maxNumber: 3
        });
    }]);
ngDroCore.config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeSpinner = true;
        cfpLoadingBarProvider.includeBar = true;
    }]);

//******************************* CONTROLLERS ***********************************
ngDroCore.controller('ngDroCoreLoginCtrl', require('./components/login/loginCtrl'));
ngDroCore.controller('ngDroCoreMainCtrl', require('./components/main/mainCtrl'));
ngDroCore.controller('ngDroCoreLogoutCtrl', require('./components/logout/logoutCtrl'));
//******************************* DIRECTIVES ***********************************
ngDroCore.directive('ngDroCoreDirectiveInjector', require('./directives/directiveInjector/directiveInjector'));
ngDroCore.directive('ngDroCoreLanguageSwitch', require('./directives/languageSwitch/languageSwitchDirective'));

//******************************* SERVICES ***********************************
ngDroCore.service('ngDroCoreNavBar', require('./services/NavBarInjector'));
ngDroCore.service('toastService', require('./services/toastService'));

//******************************* FILTERS ***********************************
ngDroCore.filter('capitalizeString', require('./filters/capitalizeFilter.js'));

//******************************* CONSTANTS ***********************************
ngDroCore.constant('APPLICATION_NAME', "Astral Infomobilit&#224");


ngDroCore.run(['$rootScope', 'MainViews', 'StatesHandler', 'ngDroCoreNavBar', 'translateFilter', 'APPLICATION_NAME', function ($rootScope, MainViews, StatesHandler, ngDroCoreNavBar, translateFilter, APPLICATION_NAME) {
        /** Registo il modulo per il menù **/
        
        $rootScope.APPLICATION_NAME=APPLICATION_NAME;

//        MainViews.register({
//            title: 'Logout',
//            state: 'logout',
//            iconClass: 'fa fa-fw fa-power-off',
//            order: 999
//        });

        //UAA        
        MainViews.unregister('uaa-module-profile-detail');
        StatesHandler.unregister('uaa-module-profile-detail');
        
        MainViews.unregister('uaa-module','uaa-module-company-list');
        StatesHandler.unregister('uaa-module','uaa-module-company-list');
        
        MainViews.unregister('uaa-module','uaa-module-template-list');
        StatesHandler.unregister('uaa-module','uaa-module-template-list');
        
        
        //ngMAP
        MainViews.unregister('g-map-index');
        StatesHandler.unregister('g-map-index');
        
        //demoModule
        MainViews.unregister('demo-module');
        StatesHandler.unregister('demo-module');
        
        var languagesScope = {};
        languagesScope.languages = [
            {
                title: 'ngDro-core.italian',
                code: 'it',
                short: 'IT'
            }, {
                title: 'ngDro-core.english',
                code: 'en',
                short: 'EN'
            }
        ];

//          CONTROLLO SELEZIONE LINGUA --- DA RIATTIVARE QUANDO VERRA' IMPLEMENTATA CORRETTAMENTE LA GESTIONE LINGUA LATO BE
//        ngDroCoreNavBar.register({
//            html: '<div ng-dro-core-language-switch languages="languages"></div>',
//            data: languagesScope,
//            position: 1
//        });

    }]);



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/module.js
// module id = 296
// module chunks = 0